import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";
import { Item } from "@/features/item/models/Item";

export interface PromotionCreateRequestParams {
  shopId: number;
  name: string;
  startDate: string;
  endDate: string | undefined;
  orderLimit?: number;
  orderItemLimit?: number | null;
  holdWhenDepleted: boolean;
  channels: number[];
  conditions: PromotionCondition[];
  inuse: boolean;
}

export interface PromotionUpdateRequestParams {
  id: number;
  name: string;
  startDate: string;
  endDate: string | undefined;
  orderLimit?: number;
  orderItemLimit?: number | null;
  holdWhenDepleted: boolean;
  channels: number[];
  conditions: PromotionCondition[];
  deletePromotionConditionId?: number[];
  inuse: boolean;
}

export interface PromotionCondition {
  id?: number;
  type: string;
  conditionItemGroups?: PromotionConditionItemGroups[];
  itemGroups: PromotionItemGroups[];
  priceRange?: number;
  priceOrder?: number;
  deleteConditionsItemGroupId?: number[];
  deletePromotionItemGroupId?: number[];
}

export interface PromotionConditionItemGroups {
  id?: number;
  items: PromotionConditionItem[];
  deletePromotionConditionItemId?: number[];
}

export interface PromotionItemGroups {
  id?: number;
  items: PromotionItem[];
  deletePromotionItemId?: number[];
}

export interface PromotionItem {
  id?: number;
  itemSku: string;
  quantity: number;
}

export interface PromotionConditionItem {
  id?: number;
  itemSku: string;
  quantity: number;
}

export interface PromotionCheckRequestParams {
  shopId: number;
  date: string;
  channel: number;
  items: {
    itemId: number;
    quantity: number;
  }[];
  price: number;
}

export class PromotionClient {
  constructor(private httpClient: HTTPClient) {}

  public async postPromotions(
    params: PromotionCreateRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/promotions",
      method: "POST",
      data: params
    });
    return data;
  }

  public async getPromotions(params: PaginationRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/promotions",
      method: "GET",
      params
    });

    return data;
  }

  public async getPromotion(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/promotions/${id}`,
      method: "GET"
    });

    return data;
  }

  public async checkPromotion(
    params: PromotionCheckRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/promotions/check",
      method: "POST",
      data: params
    });
    return data;
  }

  public async patchPromotions(
    params: PromotionUpdateRequestParams
  ): Promise<any> {
    const { id, ...body } = params;
    const { data } = await this.httpClient.request({
      url: `/promotions/${id}`,
      method: "PATCH",
      data: body
    });

    return data;
  }

  public async deletePromotions(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/promotions/${id}`,
      method: "DELETE"
    });

    return data;
  }
}
